import { cva } from "class-variance-authority";
import { forwardRef } from "react";

const labelVariants = cva(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 "
);

const Label = forwardRef<HTMLLabelElement, ILabelProps>(
  ({ className, children, htmlFor, ...props }, ref) => (
    <label
      ref={ref}
      className={`${labelVariants()} ${className}`}
      htmlFor={htmlFor}
      {...props}
    >
      {children}
    </label>
  )
);
Label.displayName = "Label";

export default Label;
